import { NAVY } from '../../styles/tokens';

export default function SaveDraftModal({ count, onSave, onDiscard, onKeep }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
    }}>
      <div style={{
        background: '#fff',
        border: `1.5px solid ${NAVY}`,
        borderRadius: 16,
        boxShadow: '0 4px 24px rgba(27,58,107,0.18)',
        padding: '32px 36px',
        maxWidth: 420,
        width: '90%',
        animation: 'fadeUp 0.2s ease',
      }}>
        <div style={{ fontSize: 20, fontWeight: 'bold', color: NAVY, marginBottom: 8 }}>
          Recibos sin Guardar
        </div>
        <div style={{ fontSize: 14, color: '#555', marginBottom: 24 }}>
          Tienes {count} recibo{count !== 1 ? 's' : ''} sin guardar. ¿Qué deseas hacer?
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button
            onClick={onSave}
            style={{
              background: NAVY, color: '#fff', border: 'none', borderRadius: 8,
              padding: '11px 0', fontWeight: 'bold', fontSize: 14, cursor: 'pointer',
              fontFamily: 'Calibri, sans-serif',
            }}
          >
            💾 Guardar como Borrador
          </button>
          <button
            onClick={onDiscard}
            style={{
              background: '#fff', color: '#c0392b', border: '1.5px solid #c0392b',
              borderRadius: 8, padding: '11px 0', fontWeight: 'bold', fontSize: 14,
              cursor: 'pointer', fontFamily: 'Calibri, sans-serif',
            }}
          >
            🗑 Descartar Cambios
          </button>
          <button
            onClick={onKeep}
            style={{
              background: '#fff', color: NAVY, border: `1.5px solid ${NAVY}`,
              borderRadius: 8, padding: '11px 0', fontWeight: 'bold', fontSize: 14,
              cursor: 'pointer', fontFamily: 'Calibri, sans-serif',
            }}
          >
            ← Seguir Editando
          </button>
        </div>
      </div>
    </div>
  );
}
